import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/jiashow.png';
import _imports_1 from '../assets/image/jianshow.png';
const _withScopeId = n => (_pushScopeId("data-v-6378e592"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-major-botton"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "tk-function"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
import { reactive, toRefs } from "vue";
import { useRouter } from "vue-router";

import { onActivated } from 'vue';
export default {
  __name: 'majorBotton',
  props: {
    listData: {
      type: Array,
      default: [{
        name: '开奖现场',
        icon: require('../assets/image/major/2057.png'),
        path: '/lottery'
      }, {
        name: '高手论坛',
        icon: require('../assets/image/major/2127.png'),
        path: '/master'
      }, {
        name: '工具宝箱',
        icon: require('../assets/image/major/2130.png'),
        path: '/tool'
      }, {
        name: '聊天室',
        icon: require('../assets/image/major/2129.png'),
        path: '1'
      }, {
        name: '资料大全',
        icon: require('../assets/image/major/2131.png'),
        path: '/materials'
      }]
    }
  },
  emits: ['majorTab'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    let data = reactive({
      show: false
    });
    let {
      show
    } = toRefs(data);
    let closed = () => {
      data.show = false;
    };
    let majorTab = item => {
      data.show = false;
      emits('majorTab', item);
      if (item.path != '1') {
        router.push({
          path: item.path
        });
      }
    };
    onActivated(() => {
      data.show = false;
    });
    return (_ctx, _cache) => {
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(show) ? (_openBlock(), _createBlock(_component_van_overlay, {
        key: 0,
        show: _unref(show),
        "z-index": "999",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _isRef(show) ? show.value = false : show = false, ["stop"]))
      }, null, 8, ["show"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "tk-major-image",
        onClick: _cache[1] || (_cache[1] = $event => _isRef(show) ? show.value = true : show = true)
      }, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: _normalizeClass(_unref(show) ? 'tk-major-closed' : 'tk-major-closed acitves'),
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => _unref(closed) && _unref(closed)(...args), ["stop"]))
      }, _hoisted_6, 2)]), _createElementVNode("ul", {
        style: _normalizeStyle({
          'z-index': _unref(show) ? 1000 : 0
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listData, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(_unref(show) ? '' : 'acitve'),
          key: index,
          onClick: $event => _unref(majorTab)(item)
        }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("img", {
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_8)], 10, _hoisted_7);
      }), 128))], 4)])], 64);
    };
  }
};